import { render, staticRenderFns } from "./VCollapse.vue?vue&type=template&id=5f048c7c&scoped=true&"
import script from "./VCollapse.vue?vue&type=script&lang=js&"
export * from "./VCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f048c7c",
  null
  
)

export default component.exports